<template>
  <div class="pic-zoom">
    <div
      class="preview-box"
      @mousemove="move($event)"
      @mouseleave="out"
      ref="previewBox"
      @mouseenter="enter"
    >
      <img class="fistpic" :src="previewImg">
      <div class="mousehover" ref="hoverBox" v-show="maskShow"></div>
    </div>
    <div class="zoom-box" v-show="zoomVisiable" ref="zoomBox">
      <img :src="previewImg" ref="bigImg">
    </div>
  </div>
</template>

<script>
  function offset (el) {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    if (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    };
    return {
      left: left,
      top: top
    };
  }
  export default {
    name: 'picZoom',
    props: {
      previewImg: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        zoomVisiable: false,
        maskShow: false
      };
    },
    methods: {
      enter () {
        this.maskShow = true;
      },
      out () {
        this.zoomVisiable = false;
        this.maskShow = false;
      },
      move (ev) {
        this.init();
        // 鼠标距离屏幕距离
        let moveX = ev.clientX;
        let moveY = ev.clientY;
        // 大盒子距离顶部的距离
        let offsetLeft = offset(this.oPreviewBox).left;
        let offsetTop = offset(this.oPreviewBox).top;
        let left = moveX - offsetLeft - this.houverWidth / 2;
        let top;
        if (this.scroll > 0) {
          top = moveY - offsetTop + this.scroll - this.houverHeight / 2;
        } else {
          top = moveY - offsetTop - this.houverHeight / 2;
        }
        let maxWidth = this.pWidth - this.houverWidth;
        let maxHeight = this.pWidth - this.houverHeight;
        left = left < 0 ? 0 : left > maxWidth ? maxWidth : left;
        top = top < 0 ? 0 : top > maxHeight ? maxHeight : top;
        let percentX = left / (maxWidth);
        let percentY = top / (maxHeight);
        this.oHoverBox.style.left = left + 'px';
        this.oHoverBox.style.top = top + 'px';
        this.oBigImg.style.left = percentX * (this.bWidth - this.imgWidth) + 'px';
        this.oBigImg.style.top = percentY * (this.bHeight - this.imgHeight) + 'px';
        this.$emit('move', ev);
        this.zoomVisiable = true;
      },
      init () {
        this.oHoverBox = this.$refs.hoverBox;
        this.oPreviewBox = this.$refs.previewBox;
        this.oBigImg = this.$refs.bigImg;
        this.imgBox = this.$refs.zoomBox;
        this.houverWidth = this.oHoverBox.offsetWidth;
        this.houverHeight = this.oHoverBox.offsetHeight;
        this.pWidth = this.oPreviewBox.offsetWidth;
        this.pHeight = this.oPreviewBox.offsetHeight;
        this.imgWidth = this.oBigImg.offsetWidth;
        this.imgHeight = this.oBigImg.offsetHeight;
        this.bWidth = this.imgBox.offsetWidth;
        this.bHeight = this.imgBox.offsetHeight;
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      }
    }
  };
</script>
  
<style>
    .preview-box {
      width: 370px;
      height: 370px;
      border: 1px solid #dddddd;
      position: relative;
    }
    .preview-box .fistpic{
      width: 100%;
      height: 100%;
    }
    .preview-box .mousehover{
      width: 130px;
      height: 130px;
      position: absolute;
      background-color: #000;
      opacity: .3;
      border: 1px solid #ccc;
      z-index: 101;
    }
    .zoom-box {
      top: 0px;
      left: 665px;
      width: 550px;
      height: 550px;
      border: 1px solid #ccc;
      position: absolute;
      overflow: hidden;
      z-index: 100;
      background: #FFF;
    }
    .zoom-box img {
        width: 800px;
        height: 800px;
        position: absolute;
        border: 0px;
        display: block;
        left: -100.286px;
        top: -125.357px;
      }
</style>